import React from 'react';

import { Heading, Stack, HStack, Icon, Skeleton, Text } from '@ecoinvent/ui';
import { BiRuler, BiCalendar } from 'react-icons/bi';
import { FiPackage, FiPieChart } from 'react-icons/fi';
import { IoEarth } from 'react-icons/io5';

import AppCard from 'components/UI/AppCard';
import useVersionInfo from 'hooks/useVersionInfo';

type KeyData = {
  geography?: string;
  geography_short_name?: string;
  reference_product?: string;
  unit?: string;
  time_period?: string;
  activity_type?: string;
};

type Props = { isLoading?: boolean } & KeyData;

const KeyData = ({
  geography,
  geography_short_name,
  reference_product,
  unit,
  time_period,
  activity_type,
  isLoading,
}: Props) => {
  const { system_model } = useVersionInfo();

  return (
    <AppCard>
      <Heading size="md">Key Data</Heading>
      <Stack spacing={6}>
        <Stack spacing={0.5}>
          <Skeleton isLoaded={!isLoading} alignSelf={'flex-start'}>
            <HStack>
              <Icon as={IoEarth} />
              <Heading size="sm">Geography</Heading>
            </HStack>
          </Skeleton>
          <Skeleton minH={'16px'} isLoaded={!isLoading}>
            <Text>
              {geography} ({geography_short_name})
            </Text>
          </Skeleton>
        </Stack>
        {system_model !== 'undefined' && (
          <Stack spacing={0.5}>
            <Skeleton isLoaded={!isLoading} alignSelf={'flex-start'}>
              <HStack>
                <Icon as={FiPackage} />
                <Heading size="sm">Functional Flow</Heading>
              </HStack>
            </Skeleton>
            <Skeleton minH={'16px'} isLoaded={!isLoading}>
              <Text>{reference_product}</Text>
            </Skeleton>
          </Stack>
        )}
        {system_model !== 'undefined' && (
          <Stack spacing={0.5}>
            <Skeleton isLoaded={!isLoading} alignSelf={'flex-start'}>
              <HStack>
                <Icon as={BiRuler} />
                <Heading size="sm">Unit</Heading>
              </HStack>
            </Skeleton>
            <Skeleton minH={'16px'} isLoaded={!isLoading}>
              <Text>{unit}</Text>
            </Skeleton>
          </Stack>
        )}
        <Stack>
          <Skeleton isLoaded={!isLoading} alignSelf={'flex-start'}>
            <HStack>
              <Icon as={BiCalendar} />
              <Heading size="sm">Time Period</Heading>
            </HStack>
          </Skeleton>
          <Skeleton minH={'16px'} isLoaded={!isLoading}>
            <Text>{time_period}</Text>
          </Skeleton>
        </Stack>
        <Stack>
          <Skeleton isLoaded={!isLoading} alignSelf={'flex-start'}>
            <HStack>
              <Icon as={FiPieChart} />
              <Heading size="sm">Activity Type</Heading>
            </HStack>
          </Skeleton>
          <Skeleton minH={'16px'} isLoaded={!isLoading}>
            <Text>{activity_type}</Text>
          </Skeleton>
        </Stack>
      </Stack>
    </AppCard>
  );
};

export default KeyData;
